import { isRTL } from 'core/services/language';

export const formatFileSize = (sizeInKB: number) => {
	if (sizeInKB >= 1024) {
		return `${(sizeInKB / 1024)?.toFixed(1)} ${isRTL() ? 'ميغابايت' : 'MB'}`;
	} else {
		return `${(sizeInKB)?.toFixed(1)} ${isRTL() ? 'كيلوبايت' : 'KB'}`;
	}
};
